import React from "react";
import { useTheme } from "@emotion/react";
import { TopRipBorder, BottomRipBorder } from "../Fx";
import { Container, Main } from "./styles";
import Snippet, { SnippetType } from "myplan/components/Snippet";

import { AppTheme } from "myplan/utils/theme";

const MyResourcesCtaSnippets = ({ snippets }) => {
	const {
		color: { enabled },
	}: AppTheme = useTheme() as AppTheme;

	const borderStyle = { color: enabled };

	return (
		<Container>
			<TopRipBorder style={borderStyle} width="100%" />
			<Main>
				{snippets.map((snippet, index, parent) => (
					<Snippet
						key={snippet._id}
						type={SnippetType.Resource}
						resource={snippet.resource}
						resourceCtaType={snippet.resourceCtaType}
						resourceCtaTitle={snippet.resourceCtaTitle}
						iconStyle={{ color: "#ffffff" }}
						containerStyle={{
							paddingHorizontal: 0,
							marginBottom: index === parent.length - 1 ? 20 : 28,
						}}
					/>
				))}
			</Main>
			<BottomRipBorder style={borderStyle} width="100%" />
		</Container>
	);
};

export default MyResourcesCtaSnippets;
